import { MDSButtonVariant } from "@/mds";
import type { ReactNode } from "react";

export enum ConfigurationPermissionStatus {
  Initial = "initial",
  Loading = "loading",
  Granted = "granted",
  Denied = "denied",
  Timeout = "timeout",
}

export enum ConfigurationListItemKind {
  Permission = "permission",
  Toggle = "toggle",
  Divider = "divider",
  Button = "button",
}

export type ConfigurationListItem =
  | {
      kind: ConfigurationListItemKind.Permission;
      id: string;
      title: ReactNode;
      description?: ReactNode;
      status: ConfigurationPermissionStatus;
      onEnable: () => Promise<void> | void;
      onOpenSystemPreferences?: () => Promise<void> | void;
    }
  | {
      kind: ConfigurationListItemKind.Toggle;
      id: string;
      title: ReactNode;
      description?: ReactNode;
      checked: boolean;
      onChange: (checked: boolean) => void;
    }
  | {
      kind: ConfigurationListItemKind.Button;
      id: string;
      title: ReactNode;
      description?: ReactNode;
      actionLabel: ReactNode;
      variant?: MDSButtonVariant;
      onClick: () => Promise<void> | void;
    }
  | {
      kind: ConfigurationListItemKind.Divider;
      id: string;
    };
